







































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { MedicalSpecification } from "@/components/medicalEdit/types";
import EditDayChangePicker from "@/components/common/EditDayChangePicker.vue";
import NumberInput from "@/components/common/NumberInput.vue";

@Component({
  components: { EditDayChangePicker, NumberInput }
})
export default class OtherMedical3 extends Vue {
  @Prop() tab!: MedicalSpecification;

  // textareaの表示用ローカル変数。tab.notices_special_other_textを直接書き換えない
  private displayText = "";

  mounted() {
    this.displayText = this.formatForDisplay(
      this.tab.notices_special_other_text
    );
  }

  // "YYYY-MM-DD,minutes\n..." -> PDFに出力されるテキストと同形式に変換（表示用）
  // ro: "[令和R年MM月DD日][住所][片道時間][看護時間]"（全角スペース区切り）
  // i: "[住所][片道時間]"（text が空で住所がある場合）
  private formatForDisplay(text: string): string {
    const sep = "　"; // 全角スペース
    const address = this.tab.notices_special_address || "";
    const reqTime = this.tab.notices_special_requirement_time || 0;

    // イ: notices_special_other_text が空 かつ 住所あり
    if (!text && address) {
      return `${address}${sep}${reqTime}`;
    }

    // ロ: "YYYY-MM-DD,minutes\n..." 形式
    if (text && /\d{4}-\d{2}-\d{2},\d+/.test(text)) {
      return text
        .split("\n")
        .filter(line => line.includes(","))
        .map(line => {
          const parts = line.split(",");
          if (parts.length < 2) return line;
          const dateParts = parts[0].trim().split("-");
          if (dateParts.length !== 3) return line;
          const [year, month, day] = dateParts;
          const reiwa = String(parseInt(year, 10) - 2018).padStart(2, "0");
          const nursingMin = parts[1].trim();
          return `令和${reiwa}年${month}月${day}日${sep}${address}${sep}${reqTime}${sep}${nursingMin}`;
        })
        .join("\n");
    }

    return text;
  }

  private addEmergencyReason() {
    this.tab.emergency_reasons.push({
      id: 0,
      medical_specification_id: this.tab.id,
      office_id: this.tab.office_id,
      date_str: "",
      text: "",
      created_at: null,
      updated_at: null,
      deleted_at: null
    });
    return;
  }
  private delEmergencyReason(idx: number) {
    this.tab.emergency_reasons.splice(idx, 1);
    return;
  }
}
